import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SuperadminRoutingModule } from './superadmin-routing.module';
import { SuperadminComponent } from './superadmin.component';
import { ChannelPartnerComponent } from './master/channelpartner/channelpartner.component';
import { SchoolComponent } from './master/school/school.component';
import { BranchComponent } from './master/branch/branch.component';
import { SessionComponent } from './master/session/session.component';
import { ClassgroupComponent } from './master/classgroup/classgroup.component';
import { ClassComponent } from './master/class/class.component';
import { SectionComponent } from './master/section/section.component';
import { CountryComponent } from './master/country/country.component';
import { StateComponent } from './master/state/state.component';
import { CityComponent } from './master/city/city.component';
import { SuperPageSetUpComponent } from './admin/superpagesetup/superpagesetup.component';
import { PackageComponent } from './subscription/package/package.component';
import { FeatureComponent } from './subscription/feature/feature.component';
import { PackageSiteMapComponent } from './subscription/packagesitemap/packagesitemap.component';
import { SubscriptionComponent } from './subscription/subscription/subscription.component';
import { MobilepackagesitemapComponent } from './subscription/mobilepackagesitemap/mobilepackagesitemap.component';
import { SmsapiComponent } from './sms/smsapi/smsapi.component';
import { TransactionalaccountComponent } from './sms/transactionalaccount/transactionalaccount.component';
import { PromotionalAccountComponent } from './sms/promotional-account/promotional-account.component';
import { WebsiteComponent } from './cms/website/website.component';
import { SliderComponent } from './cms/slider/slider.component';
import { SiteMapComponent } from './cms/site-map/site-map.component';
import { AccountSiteMapComponent } from './cms/account-site-map/account-site-map.component';
import { TemplateComponent } from './template/template/template.component';
import { TemplateBranchMapComponent } from './template/template-branch-map/template-branch-map.component';
import { AdsSliderComponent } from './ads/ads-slider/ads-slider.component';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule, TypeaheadModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PackagematrixComponent } from './subscription/packagematrix/packagematrix.component';
import { PackagesaleComponent } from './subscription/packagesale/packagesale.component';
import { PackagepriceComponent } from './subscription/packageprice/packageprice.component';
import { MediaFileComponent } from './resource/media-file/media-file.component';
import { KnowledgeBaseComponent } from './resource/knowledge-base/knowledge-base.component';
import { KnowledgeBaseSearchComponent } from './resource/knowledge-base-search/knowledge-base-search.component';
import { BlogCategoryComponent } from './resource/blog-category/blog-category.component';
import { BlogPostComponent } from './resource/blog-post/blog-post.component';
import { BlogPostSearchComponent } from './resource/blog-post-search/blog-post-search.component';
import { NgxEditorModule } from 'ngx-editor';
import { SuperdashboardComponent } from './dashboard/superdashboard/superdashboard.component';
import { OrganizationComponent } from './admin/organization/organization.component';
import { SuperTicketComponent } from './super-ticket/super-ticket.component';
import { SuperTicketDetailsComponent } from './super-ticket-details/super-ticket-details.component';
import { JosaUrlComponent } from './cms/josa-url/josa-url.component';
import { CurrencyComponent } from './subscription/currency/currency.component';
import { PackageGroupCountryComponent } from './subscription/package-group-country/package-group-country.component';




@NgModule({
  declarations: [SuperadminComponent,SuperdashboardComponent, ChannelPartnerComponent, SchoolComponent, BranchComponent,
     SessionComponent, ClassgroupComponent, ClassComponent, SectionComponent, CountryComponent,
     StateComponent, CityComponent, SuperPageSetUpComponent, PackageComponent, FeatureComponent, 
     PackageSiteMapComponent, SubscriptionComponent, MobilepackagesitemapComponent, SmsapiComponent,
     TransactionalaccountComponent, PromotionalAccountComponent, WebsiteComponent, SliderComponent, 
     SiteMapComponent, AccountSiteMapComponent, TemplateComponent, TemplateBranchMapComponent,
     AdsSliderComponent, PackagematrixComponent, PackagesaleComponent, 
     PackagepriceComponent, MediaFileComponent, KnowledgeBaseComponent, KnowledgeBaseSearchComponent, 
     BlogCategoryComponent, BlogPostComponent, BlogPostSearchComponent, OrganizationComponent,
     SuperTicketComponent, SuperTicketDetailsComponent, JosaUrlComponent, CurrencyComponent, PackageGroupCountryComponent],
  imports: [
    CommonModule,
    SuperadminRoutingModule,
    FormsModule ,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxEditorModule,
    BsDatepickerModule.forRoot(),    
    TypeaheadModule.forRoot(),
  ]
})
export class SuperAdminModule { }
